// @flow

import { WEB_TYPES_KEYS, WEB_TYPES_KEYS_TYPE } from '../Redux/SettingsRedux'
import { checkProps } from './SerializerFunctions'
import { fixMileageAllianzPillow } from '../utils/utils'

// types
import type { SelectedTariffs, UseAllTariffsIfEmpty } from '../Types/QuoteType'
import type { RefreshSelectedTariffs } from '../Types/QuoteType'
import type { QuoteRequestDataType } from '../Redux/Types/QuoteStateType'
import type QuoteInstance from '../Controllers/QuoteInstance'

export type QuoteAsyncRequestSerializerType = {
  previousRequestId: string,
  productDescriptorValues: { [key: string]: any },
  enabledCalculators: Array<string>,
  selectedTariffs: SelectedTariffs,
  website: WEB_TYPES_KEYS_TYPE,
  useAllTariffsIfEmpty: UseAllTariffsIfEmpty,
  affiliate: string,
}

export type RefreshQuoteAsyncRequestSerializerType = {
  created: string,
  enabledCalculators: Array<string>,
  id: string,
  previousRequestId: string,
  productDescriptorValues: { [key: string]: any },
  productDetailValues: { [key: string]: any },
  selectedTariffs: RefreshSelectedTariffs | SelectedTariffs,
  useAllTariffsIfEmpty: UseAllTariffsIfEmpty,
  website: WEB_TYPES_KEYS_TYPE,
  affiliate: string,
}

export const quoteAsyncRequestSerializer = (
  props: Object,
  productDescriptorValues: { [key: string]: any },
  requestQuoteData: QuoteRequestDataType,
  discounts: { [key: string]: any },
  name: ?string,
  enabledCalculators: ?Array<string>,
  useFilters: boolean = false,
  pushActiveQuoteFilters?: Object,
): QuoteAsyncRequestSerializerType => {
  const { previousRequestId, webType, activeQuoteFilters, userData, productName } = props
  checkProps(
    ['webType', 'activeQuoteFilters', 'enabledCalculators', 'isBackOffice', 'affiliate', 'productName'],
    props,
    name || 'quoteAsyncRequestSerializer',
  )

  const requestQuoteDataEnabledCalculators = { ...requestQuoteData }
  if (Array.isArray(enabledCalculators) && enabledCalculators.length > 0) {
    requestQuoteDataEnabledCalculators.enabledCalculators = enabledCalculators
  } else if (
    requestQuoteDataEnabledCalculators.enabledCalculators.length === 0 &&
    props.enabledCalculators &&
    (useFilters || !props.isBackOffice)
  ) {
    requestQuoteDataEnabledCalculators.enabledCalculators = props.enabledCalculators
  }
  // TODO fix
  if (
    requestQuoteDataEnabledCalculators.useAllTariffsIfEmpty.tpl &&
    requestQuoteDataEnabledCalculators.useAllTariffsIfEmpty.cic &&
    requestQuoteDataEnabledCalculators.enabledCalculators.length === 0
  ) {
    if (requestQuoteDataEnabledCalculators.enabledCalculators.length) {
      requestQuoteDataEnabledCalculators.enabledCalculators.push('CarDirect')
    } else {
      requestQuoteDataEnabledCalculators.enabledCalculators = ['CarDirect']
    }
  }

  const properties = {}

  if (userData.bonusType === 'manually') {
    const bonusProps = {
      monthsWithAccidents: 'manualBMMonths',
      countOfAccidents: 'manualBMAccidents',
    }
    Object.keys(bonusProps).forEach((key) => {
      properties[bonusProps[key]] = userData[key]
    })
  }

  // PG-1933 fake email to enable el. communication
  if (productName === 'car' && !productDescriptorValues.elCommunicationAgreed) {
    productDescriptorValues.elCommunicationAgreed = true
    if (productDescriptorValues.policyHolder && !productDescriptorValues.policyHolder.email) {
      productDescriptorValues.policyHolder.email = 'info@suri.cz'
    }
  }

  productDescriptorValues = fixMileageAllianzPillow(
    productDescriptorValues,
    requestQuoteDataEnabledCalculators.enabledCalculators,
  )

  return {
    affiliate: props.affiliate,
    previousRequestId,
    productDescriptorValues,
    properties,
    website: WEB_TYPES_KEYS[webType],
    filters: useFilters ? pushActiveQuoteFilters || activeQuoteFilters : {},
    discountValues: discounts,
    ...requestQuoteDataEnabledCalculators,
  }
}

export const refreshQuoteAsyncRequestSerializer = (
  props: Object,
  productDescriptorValues: { [key: string]: any },
  requestQuoteData: QuoteRequestDataType,
  supplementaryInsurances: { [key: string]: any },
  quote: QuoteInstance,
  discounts: { [key: string]: any },
  quoteKey?: string,
): RefreshQuoteAsyncRequestSerializerType => {
  let selectedTariffs = quote.subProductToTariffName
  if (quoteKey) {
    selectedTariffs = {
      [quoteKey]: selectedTariffs[quoteKey],
    }
  }
  return {
    ...quoteAsyncRequestSerializer(
      props,
      productDescriptorValues,
      requestQuoteData,
      discounts,
      'refreshQuoteAsyncRequestSerializer',
    ),
    created: quote.quoteRequest.created,
    id: quote.id,
    productDetailValues: supplementaryInsurances,
    selectedTariffs,
  }
}
